import { render, staticRenderFns } from "./gerarAntecipacaoExoneracaoObitos.vue?vue&type=template&id=92f67c0e"
import script from "./gerarAntecipacaoExoneracaoObitos.vue?vue&type=script&lang=js"
export * from "./gerarAntecipacaoExoneracaoObitos.vue?vue&type=script&lang=js"
import style0 from "./gerarAntecipacaoExoneracaoObitos.vue?vue&type=style&index=0&id=92f67c0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports